import { render, staticRenderFns } from "./ProductExpirationAlerts.vue?vue&type=template&id=4edcc717&scoped=true"
import script from "./ProductExpirationAlerts.vue?vue&type=script&lang=js"
export * from "./ProductExpirationAlerts.vue?vue&type=script&lang=js"
import style0 from "./ProductExpirationAlerts.vue?vue&type=style&index=0&id=4edcc717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edcc717",
  null
  
)

export default component.exports